module.exports = __webpack_public_path__ + "static/media/previous.34c9c7e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/com/sixdee/crbtportal/ui/toolkit/carousel/previous.svg
// module id = 979
// module chunks = 0